import { render, staticRenderFns } from "./manage-lits.html?vue&type=template&id=5fa942bc&scoped=true&external"
import script from "./manage-lits.js?vue&type=script&lang=js&external"
export * from "./manage-lits.js?vue&type=script&lang=js&external"
import style0 from "./manage-lits.scss?vue&type=style&index=0&id=5fa942bc&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa942bc",
  null
  
)

export default component.exports